import {Component, ContentChildren, EventEmitter, Input, OnInit, Output, QueryList} from '@angular/core';
import {AppConfig} from '@app/models/app-config.model';
import {ConfigService} from '@app/services/config.service';
import {Footer, Header} from 'primeng/primeng';
import {Observable, Subject} from 'rxjs';

@Component({
  selector: 'app-dialog',
  template: `
    <p-dialog [(visible)]='context'
              [header]='header'
              [draggable]='draggable'
              [resizable]='resizable'
              [minWidth]='minWidth'
              [minHeight]='minHeight'
              [width]='width'
              [height]='height'
              [contentStyle]='contentStyle'
              [modal]='modal'
              [blockScroll]='blockScroll'
              [closeOnEscape]='closeOnEscape'
              [dismissableMask]='dismissableMask'
              [rtl]='rtl'
              [closable]='closable'
              [responsive]='responsive'
              [breakpoint]='breakpoint'
              [appendTo]='appendTo'
              [style]='style'
              [styleClass]='styleClass'
              [showHeader]='showHeader'
              [positionLeft]='positionLeft'
              [positionTop]='positionTop'
              [baseZIndex]='baseZIndex'
              [autoZIndex]='autoZIndex'
              [minX]="minX"
              [minY]="minY"
              [focusOnShow]="focusOnShow"
              [maximizable]="maximizable"
              [transitionOptions]="transitionOptions"
              (onShow)='shown.emit($event)'
              (onHide)='hidden.emit($event)'
    >
      <p-header *ngIf='headerFacet && headerFacet.first'>
        <ng-content select='p-header'></ng-content>
      </p-header>

      <ng-content></ng-content>

      <p-footer *ngIf='footerFacet && footerFacet.first'>
        <ng-content select='p-footer'></ng-content>
      </p-footer>
    </p-dialog>
  `
})
export class SimpleDialogComponent implements OnInit {
  // From PrimeNG Dialog
  @Input() header: string;
  @Input() draggable = true;
  @Input() resizable = true;
  @Input() minWidth = 150;
  @Input() minHeight = 150;
  @Input() width: number;
  @Input() height: any;
  @Input() contentStyle: any;
  @Input() visible = false;
  @Input() modal = true;
  @Input() blockScroll = false;
  @Input() closeOnEscape = true;
  @Input() dismissableMask = false;
  @Input() rtl = false;
  @Input() closable = true;
  @Input() responsive = true;
  @Input() breakpoint = 640;
  @Input() appendTo: any;
  @Input() style: any;
  @Input() styleClass: string;
  @Input() showHeader = true;
  @Input() positionLeft: number;
  @Input() positionTop: number;
  @Input() baseZIndex = 0;
  @Input() autoZIndex = true;
  @Input() minX = 0;
  @Input() minY = 0;
  @Input() focusOnShow = true;
  @Input() maximizable = true;
  @Input() transitionOptions = '400ms cubic-bezier(0.25, 0.8, 0.25, 1)';
  @Input() maximize = false;

  @Output() shown = new EventEmitter<void>();
  @Output() hidden = new EventEmitter<void>();

  @Output() confirmed = new EventEmitter<void>();
  @Output() dismissed = new EventEmitter<void>();

  @ContentChildren(Header, {descendants: false}) headerFacet: QueryList<Header>;
  @ContentChildren(Footer, {descendants: false}) footerFacet: QueryList<Footer>;

  public confirmSubject: Subject<boolean>;
  public context: any;
  public result: any;

  constructor(private config: ConfigService) {
  }

  ngOnInit() {
    const appConfig = <AppConfig>this.config.app;

    if (!this.width && appConfig.dialogWidth)
      this.width = +appConfig.dialogWidth;

    if (this.maximize) {
      this.width = window.innerWidth - 100;
      this.height = window.innerHeight - 100;
    }
  }

  public show(context: any = {}): Observable<boolean> {
    this.context = context;

    this.confirmSubject = new Subject<boolean>();
    const obs = this.confirmSubject.asObservable();

    obs.subscribe((result) => {
      if (result) {
        this.confirmed.emit();
      } else {
        this.dismissed.emit();
      }

      this.reset();
    });

    return obs;
  }

  public hide(): void {
    this.reset();
  }

  public confirm(result?: any): void {
    this.result = (result != null ? result : this.context);
    this.confirmSubject.next(true);
  }

  public dismiss(): void {
    this.result = null;
    if (this.confirmSubject != null) {
      this.confirmSubject.next(false);
    }
  }

  private reset(): void {
    if (this.confirmSubject != null) {
      this.confirmSubject.unsubscribe();
      this.confirmSubject = null;
      this.context = null;
    }
  }
}
